import React from 'react';
 import {InputGroup, FormControl, Modal, Row,Col, Checkbox, Button} from 'react-bootstrap';
 import _ from "lodash";
import {v4 as uuidv4}  from 'uuid'
function linkGBGProductImageToQualityCheck(currentImageIndex,ConditionsToMatch){
    var self = this;
    let conditionToMatch = {}
    if(self.state.currentRecord.currentQualityCheckItem.customQualityCheck) {
      conditionToMatch.QualityCheckText = self.state.currentRecord.currentQualityCheckItem.label
    }else{
      conditionToMatch.QualityCheckNumber = self.state.currentRecord.currentQualityCheckItem.value
    }
    const updatedImage = {
      ...self.state.currentRecord.GBGProductImages[currentImageIndex],
      ConditionsToMatch: ConditionsToMatch.concat([
        {
          Conditions: [conditionToMatch]
        }])
    }
    const updatedImages = [... self.state.currentRecord.GBGProductImages.slice(0, currentImageIndex),
      updatedImage,
      ...self.state.currentRecord.GBGProductImages.slice(currentImageIndex + 1)];
    this.setState({
      currentRecord: {
        ...self.state.currentRecord,
        GBGProductImages: updatedImages
      }
    })
  }

export function  displayButtonToLinkQualityCheckToImage(){
    const self = this;
    let buttonText = ' Link to selected image'
    const currentImageIndex =    self.state.currentRecord.GBGProductImages.findIndex(image=> 
         image._id === self.state.currentRecord.selectedImage._id)
  const {ConditionsToMatch = []} = self.state.currentRecord.GBGProductImages[currentImageIndex]
  const conditionFound =  self.state.currentRecord.GBGProductImages.find(GBGProductImage=> {
   const conditionsToMatchForImage = GBGProductImage.ConditionsToMatch || []
    return conditionsToMatchForImage.find(conditionToMatch => {
      const {Conditions = []} = conditionToMatch
      return Conditions.find(item => {
        if (item.QualityCheckNumber) {
          return item.QualityCheckNumber == self.state.currentRecord.currentQualityCheckItem.value
        } else if (self.state.currentRecord.currentQualityCheckItem.customQualityCheck) {
          return item.QualityCheckText == self.state.currentRecord.currentQualityCheckItem.originalItemText
        }
      })
    })
  })

    if (conditionFound) {
        buttonText = 'Image already linked'
    }
    return   <Button className=" pull-left btn btn-primary " type="button"
                     disabled = {conditionFound ? true:false}
                     onClick={()=>linkGBGProductImageToQualityCheck.call(self, currentImageIndex,ConditionsToMatch )}>
        {buttonText}
    </Button>
}

function deleteLinksForDeletedQualityChecks(GBGProductImages,deletedQualityChecks){
  let updateImages
  const GBGProductImagesToUpdate = GBGProductImages.map( image => {
    const {ConditionsToMatch = []} = image
    if (ConditionsToMatch.length) {
      return {
        ...image,
        ConditionsToMatch: _.reject(ConditionsToMatch, conditionToMatch => {
          if (conditionToMatch.Conditions.length == 1) {
            if (conditionToMatch.Conditions[0].QualityCheckNumber  ==  deletedQualityChecks[0].value) {
              updateImages = true;
              return true;
            }else if(conditionToMatch.Conditions[0].QualityCheckText  ==  deletedQualityChecks[0].originalItemText) {
              updateImages = true;
              return true;
            }
          }
        })
      }
    } else {
      return image
    }
  })
  return {GBGProductImagesToUpdate, updateImages}
}
export function  onQualityChecksToIncludeChange(selectedOptions){
  const selectedOptionsCopy = selectedOptions.map(item => {
    if(item.className){
      item.customQualityCheck = true
      item.DeterministicQualityCheck = {
        Answers: [{
          AnswerText:'Yes'
        },{
          AnswerText:'No'
        }]
      };
      if(!item.originalItemText){
        item.originalItemText = item.value
      }
    }
    return  item
  })
  let dataToUpdate ={
    currentRecord: {
      ...this.state.currentRecord,
      'QualityChecksToInclude': selectedOptionsCopy
    }
  }
  let GBGProductImagesToUpdate
  let updateImages
  const deletedOptions = _.differenceBy( this.state.currentRecord.QualityChecksToInclude, selectedOptions,'value')
  const {GBGProductImages = []} = this.state.currentRecord
  if (deletedOptions.length) {

     ({ updateImages, GBGProductImagesToUpdate } =  deleteLinksForDeletedQualityChecks(GBGProductImages,deletedOptions))
    const {currentQualityCheckItem = {}} = this.state.currentRecord
    if(currentQualityCheckItem.value ==  deletedOptions[0].value){
      dataToUpdate.currentRecord.currentQualityCheckItem = {}
    }
  }

  if (updateImages) {
    dataToUpdate.currentRecord.GBGProductImages = GBGProductImagesToUpdate
  }
  this.setState(dataToUpdate)
}
export function updateCurrentQualityCheckToInclude(){
  let GBGProductImagesToUpdate
  let updateImages
  const {currentQualityCheckItem = {}} = this.state.currentRecord
  const {DeterministicQualityCheck = {}} = currentQualityCheckItem;
  const {Answers = []} = DeterministicQualityCheck;

  if (!Answers.length) {
    return this.props.displayMessage({
      messageType: 'warning',
      messageCode: 'Please, add at least one answer',
    });
  }

  let dataNotValid = Answers.some((answer) => {
    if (answer.Penalty && (isNaN(answer.Penalty) || answer.Penalty > 100 || answer.Penalty <= 0)) {
      this.props.displayMessage({
        messageType: 'warning',
        messageCode: `Answer penalty number ${answer.Penalty}  is not valid`,
      });
      return true;
    }

    if (answer.Penalty == '') {
      delete answer.Penalty;
    }

    if (answer.AnswerText == '') {
      this.props.displayMessage({
        messageType: 'warning',
        messageCode: 'Please, specify answer text',
      });
      return true;
    }
  });

  if (dataNotValid) {
    return;
  }
  let QualityChecksToUpdate = []
  if (currentQualityCheckItem.value) {
    const foundIndex = _.findIndex(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), object => 
      object.value == _.get(this.state.currentRecord, 'currentQualityCheckItem.value'));
    if (foundIndex !== -1) {
      ({ updateImages, GBGProductImagesToUpdate } =  updateQualityCheckLinkToOriginalImages.call(this, currentQualityCheckItem))
      QualityChecksToUpdate = [..._.get(this.state.currentRecord, 'QualityChecksToInclude', []).slice(0, foundIndex),
        {... currentQualityCheckItem,
          originalItemText:currentQualityCheckItem.label
        },
        ..._.get(this.state.currentRecord, 'QualityChecksToInclude', []).slice(foundIndex + 1)];
    }else{
      this.setState({
        currentRecord: {
          ...this.state.currentRecord,
          currentQualityCheckItem: {},
        }
      })
      return
    }
  } else {
    const foundItem = _.find(_.get(this.state.currentRecord, 'QualityChecksToInclude', []), item => 
      item.label == _.get(this.state.currentRecord, 'currentQualityCheckItem.label', ''))
    if (foundItem) {
      return this.props.displayMessage({
        'messageType': 'warning',
        'messageCode': 'Quality check with this label already exists',
      });
    }
    const {QualityChecksToInclude=[]} = this.state.currentRecord
    QualityChecksToUpdate = QualityChecksToInclude.concat([{
      ...currentQualityCheckItem,
      value: uuidv4(),
      originalItemText:currentQualityCheckItem.value,
      customQualityCheck: true,
    }])
  }

  let dataToUpdate = {
    currentRecord: {
      ...this.state.currentRecord,
      currentQualityCheckItem: {},
      QualityChecksToInclude: QualityChecksToUpdate
    }
  }
  if(updateImages){
    dataToUpdate.currentRecord.GBGProductImages = GBGProductImagesToUpdate
  }

  this.setState(dataToUpdate)
}
export function displayQualityCheckItemImages(qualityCheckItem){
  let {QualityCheckImages = [],ItemNumber = '',Text } = qualityCheckItem
  const {GBGProductImages=[]} = this.state.currentRecord
  let imagesForGBGProduct = []
  GBGProductImages.forEach(GBGProductImage=>{
    const {ConditionsToMatch=[]} = GBGProductImage
    ConditionsToMatch.forEach(conditionToMatch=>{
      const {Conditions=[]} = conditionToMatch
      Conditions.forEach(condition=>{
        if((condition.QualityCheckNumber && condition.QualityCheckNumber == ItemNumber) || (condition.QualityCheckText && condition.QualityCheckText == Text)){
          imagesForGBGProduct.push(GBGProductImage)
        }
      })
    })
  })

  if(imagesForGBGProduct.length) {
    QualityCheckImages = imagesForGBGProduct;
  }

  return <Col xs={10} className='left20 top15'>
    {QualityCheckImages.map((image,index)  => {
      return <span style={{
        'border-radius':10,
      }}  key={index} className="pright15"><img
        className="bot20"
        style={{
          width: 80,
          height: 80,
        }}  src={ image.URL}/></span>
    })}
  </Col>
}
 function updateQualityCheckLinkToOriginalImages(updatedItem){
  const {GBGProductImages = []} = this.state.currentRecord
  let updateImages;
  let GBGProductImagesToUpdate = GBGProductImages.map( image => {
    const {ConditionsToMatch = []} = image
    if (ConditionsToMatch.length) {
      return {
        ...image,
        ConditionsToMatch: ConditionsToMatch.map(conditionToMatch => {
          let conditionToMatchCopy = _.cloneDeep(conditionToMatch)
          if(conditionToMatchCopy.Conditions.length==1) {
            if (updatedItem.originalItemText && conditionToMatchCopy.Conditions[0].QualityCheckText == updatedItem.originalItemText) {
              updateImages = true;
              conditionToMatchCopy.Conditions[0].QualityCheckText = updatedItem.label
            }
          }
          return conditionToMatchCopy
        })
      }
    } else {
      return image
    }
  })
  return {updateImages, GBGProductImagesToUpdate}
}
function linkGBGProductImageToVariation(currentVariation, currentImageIndex,ConditionsToMatch){
   const self = this;
  const updatedImage = {
    ...self.state.currentRecord.GBGProductImages[currentImageIndex],
    ConditionsToMatch: ConditionsToMatch.concat([
      {
        Conditions: [{
          VariationLabel: currentVariation.Label,
          OptionValue: this.state.customVariationTypeValue
        }]
      }])
  }
  const updatedImages = [... self.state.currentRecord.GBGProductImages.slice(0, currentImageIndex),
    updatedImage,
    ...self.state.currentRecord.GBGProductImages.slice(currentImageIndex + 1)];
  this.setState({
    currentRecord: {
      ...self.state.currentRecord,
      GBGProductImages: updatedImages
    }
  })
}
function displayButtonToLinkVariationToImage(){
  const self = this;
  let buttonText = ' Link to selected image'
  const currentImageIndex =    self.state.currentRecord.GBGProductImages.findIndex(image=> {
    return image._id == self.state.currentRecord.selectedImage._id
  })
  const currentVariation = self.state.currentRecord.Variations[self.state.currentVariationItemIndex]

  const {ConditionsToMatch = []} = self.state.currentRecord.GBGProductImages[currentImageIndex]
  const conditionExist =  ConditionsToMatch.find(conditionToMatch => {
    const {Conditions=[]} = conditionToMatch
    return Conditions.find(item => {
      return  item.VariationLabel == currentVariation.Label && item.OptionValue == this.state.customVariationTypeValue
    })
  })
  if (conditionExist) {
    buttonText = 'Selected image already linked'
  }

  return  <Col md={6} xs={12} className="top10">
    <Button className="left10 pull-left btn btn-primary " type="button"
            disabled = {conditionExist}
            onClick={() => linkGBGProductImageToVariation.call(self,currentVariation, currentImageIndex,ConditionsToMatch) }>
      {buttonText}
    </Button>
  </Col>
}
export function displayVariationOptionEditForm(){
  const {selectedImage = {}} = this.state.currentRecord

  const self = this;
  return <div>
    <Row>

      <Col md={4} xs={6} className="top10">
        <FormControl type="text"
                     onChange={(e) => this.setState({
                       'customVariationTypeLabel': e.target.value
                     })}
                     value={this.state.customVariationTypeLabel }
                     placeholder="Label"/>
      </Col>


      <Col md={4} xs={6} className="top10">
        <FormControl type="text"
                     onChange={(e) => this.setState({
                       'customVariationTypeValue': e.target.value
                     })}
                     value={this.state.customVariationTypeValue }
                     placeholder="Value"/>
      </Col>
      <Col md={4} sm={4} xs={6} className="top10">
        <Button className="right10 pull-left btn btn-primary " type="button"
                onClick={() => this.addUpdateVariationOption() }>
          Save
        </Button>

        <Button className="left10 pull-left btn btn-primary " type="button"
                onClick={() => this.setState({
                  'currentVariationItemIndex': '',
                  currentVariationOptionIndex:'',
                }) }>
          Cancel
        </Button>

      </Col>

    </Row>
    <Row>

      <Col md={6} xs={12} className="top10">
        <FormControl type="text" componentClass="textarea"
                     onChange={(e) => this.setState({
                       'customVariationTypeGBGNote': e.target.value
                     })}
                     value={this.state.customVariationTypeGBGNote }
                     placeholder="Custom GBG Note"/>
      </Col>
      {(selectedImage._id && this.state.customVariationTypeValue) && displayButtonToLinkVariationToImage.call(self)}
      {this.state.currentRecord.currentUPCCodeItem && displayLinkToUPCCodeButton.call(self)}
    </Row>
  </div>
}
function displayLinkToUPCCodeButton(){
  const self = this;
  const variationRecord = this.state.currentRecord.Variations[this.state.currentVariationItemIndex]
   let buttonText = 'Link to selected UPC code'
  const {Label = '', UseInTitle = false} = variationRecord
  let linkToSelectedUPCCodeEnabled = true

  const foundItemIndex = _.findIndex(this.state.currentRecord.UPCCodes, function (item) {
    return item.value == self.state.currentRecord.currentUPCCodeItem.value
  })
  const currentVariation = this.state.currentRecord.Variations[this.state.currentVariationItemIndex]
  const currentOptionItem =  currentVariation.Options[this.state.currentVariationOptionIndex]
  const {VariationLinks=[]} =this.state.currentRecord.UPCCodes[foundItemIndex]
  const variationLinkExist = VariationLinks.find(variationLink => {
    return currentOptionItem &&  variationLink.VariationLabel == currentVariation.Label &&  variationLink.VariationOptionValue == currentOptionItem.value
  })
  if(Label.toLowerCase().includes('year') || !UseInTitle){
    linkToSelectedUPCCodeEnabled = false;
    buttonText = 'Can not link UPC to this variation'
  }

  if(variationLinkExist){
    buttonText = 'UPC code already linked'
    linkToSelectedUPCCodeEnabled = false;
  }
  return <Col md={6} xs={12} className="top10">

    <Button className="left10 pull-left btn btn-primary " type="button"
            disabled={!linkToSelectedUPCCodeEnabled}
            onClick={() => {
              const updatedUPCCode = {
                ...this.state.currentRecord.UPCCodes[foundItemIndex],
                VariationLinks: VariationLinks.concat([
                  {
                    VariationLabel: currentVariation.Label,
                    VariationOptionLabel: self.state.customVariationTypeLabel,
                    VariationOptionValue: self.state.customVariationTypeValue
                  }])

              }
              self.updateUPCCode(updatedUPCCode).then(function() {
                self.setState({
                  currentRecord: {
                    ...self.state.currentRecord,
                    UPCCodes: [... self.state.currentRecord.UPCCodes.slice(0, foundItemIndex),
                      updatedUPCCode,
                      ...self.state.currentRecord.UPCCodes.slice(foundItemIndex + 1)]
                  }
                })
              })
            }}>
      {buttonText}
    </Button>

  </Col>
}